import React from "react";
import MainMenucomponent from "../components/Mainmenu";


const Mainmenu = () => {
    return (
        <div>
            <MainMenucomponent/>
        </div>
    )
}
export default Mainmenu;